import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_dw_button = _resolveComponent("dw-button")!
  const _component_dw_popup = _resolveComponent("dw-popup")!

  return (_openBlock(), _createBlock(_component_dw_popup, {
    title: "Перенос даты",
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "dw-popup__form",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_the_input, {
          placeholder: "Выберите дату",
          type: "date",
          value: _ctx.state.newDate,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.newDate) = $event)),
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.validation$.newDate.$error,
          "validation-errors": _ctx.validation$.newDate.$errors
        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_select, {
          placeholder: "Период отправки",
          value: _ctx.state.periodId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.periodId) = $event)),
          loading: _ctx.data_state.periods.is_loading,
          failed: _ctx.data_state.periods.is_failed,
          "error-text": "При получении списка периодов произошла ошибка",
          searchable: false,
          options: _ctx.data_state.periods.list,
          "is-invalid": _ctx.validation$.periodId.$error,
          "validation-errors": _ctx.validation$.periodId.$errors,
          label: "title",
          onRefresh: _ctx.loadPeriods
        }, null, 8, ["value", "loading", "failed", "options", "is-invalid", "validation-errors", "onRefresh"]),
        _createVNode(_component_dw_button, {
          type: "submit",
          loading: _ctx.state.is_loading
        }, {
          default: _withCtx(() => [
            _createTextVNode("Перенести дату")
          ]),
          _: 1
        }, 8, ["loading"])
      ], 32)
    ]),
    _: 1
  }, 8, ["onClose"]))
}